"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

require("reflect-metadata");

var SerializationError_1 = require("./Error/SerializationError");

var ClassLevel_1 = require("./TypeDecorator/ClassLevel");

var PrimitiveTypeEnum_1 = require("./TypeDecorator/PrimitiveTypeEnum");

var PropertyTypeDefinition_1 = require("./TypeDecorator/PropertyTypeDefinition");

var Util_1 = require("./Util");

var replacer = function replacer(key, value) {
  return value === undefined ? null : value;
};

var Serializer =
/** @class */
function () {
  function Serializer(logger, formatOptions) {
    if (formatOptions === void 0) {
      formatOptions = {
        space: undefined
      };
    }

    this.logger = logger;
    this.formatOptions = formatOptions;
  }

  Serializer.prototype.serialize = function (input) {
    var formatOptions = this.formatOptions;

    if (Array.isArray(input) || input instanceof Map) {
      return JSON.stringify(this.prepareFromCollection(input, undefined), replacer, formatOptions.space);
    } else if (input !== null) {
      return JSON.stringify(this.convertSingleInput(input), replacer, formatOptions.space);
    } else {
      return JSON.stringify(null);
    }
  };
  /**
   * Convert a collection of input objects into a single object that can be serialized
   *
   * @param {T[] | Map<string, T> | Map<number, T>} input
   * @param collectionTypeDefinition
   * @return {object}
   */


  Serializer.prototype.prepareFromCollection = function (input, collectionTypeDefinition) {
    if (Array.isArray(input)) {
      return this.convertArrayCollection(input, collectionTypeDefinition);
    } else if (input instanceof Map) {
      return this.convertMap(input, collectionTypeDefinition);
    } else {
      return this.convertObjectCollection(input, collectionTypeDefinition);
    }
  };
  /**
   * Convert a single object into an object that can be serialized
   *
   * @param {T} input
   * @return {object|null}
   */


  Serializer.prototype.convertSingleInput = function (input) {
    return this.convertValue(input, undefined);
  };
  /**
   * Convert a single object into an object that can be serialized
   *
   * @param {T} input
   * @param typeDefinition
   * @return {any}
   */


  Serializer.prototype.convertValue = function (input, typeDefinition) {
    // If the Type Definition is given and it is a primitive type treat the value as it
    if (typeDefinition && PrimitiveTypeEnum_1.isPrimitiveTypeEnum(typeDefinition.type)) {
      return this.preparePrimitiveProperty(input, typeDefinition.type);
    } // If the input is not some kind of primitive type it must be an object


    this.assertObject(input);

    if (input instanceof Date) {
      return input;
    }

    if (input === null) {
      return null;
    }

    var target = {};

    for (var _i = 0, _a = Object.keys(input); _i < _a.length; _i++) {
      var key = _a[_i];
      this.serializeProperty(target, key, input);
    }

    return target;
  };
  /**
   * Convert an array of input objects into an array of objects that can be serialized
   *
   * This method is used to convert an input array
   *
   * @param {T[]} input
   * @param {PropertyTypeDefinition<T> | undefined} collectionTypeDefinition
   * @return {any[]}
   */


  Serializer.prototype.convertArrayCollection = function (input, collectionTypeDefinition) {
    var _this = this;

    return Array.prototype.map.call(input, function (item) {
      return _this.convertValue(item, collectionTypeDefinition);
    });
  };
  /**
   * Convert a Map of input objects into a single object that can be serialized
   *
   * This method is used to convert a dictionary or Map
   *
   * @param {Map<number | string, T>} input
   * @param {PropertyTypeDefinition<T> | undefined} collectionTypeDefinition
   * @return {ParDict}
   */


  Serializer.prototype.convertMap = function (input, collectionTypeDefinition) {
    var _this = this;

    var targetObject = {};
    input.forEach(function (value, key) {
      targetObject[key] = _this.convertValue(value, collectionTypeDefinition);
    });
    return targetObject;
  };
  /**
   * Convert a collection of input objects into a single object that can be serialized
   *
   * This method is used to convert a dictionary or Map
   *
   * @param {T} input
   * @param {PropertyTypeDefinition<T> | undefined} typeDefinition
   * @return {ParDict}
   */


  Serializer.prototype.convertObjectCollection = function (input, typeDefinition) {
    var _this = this;

    var targetObject = {};
    this.assertObject(input);
    Object.keys(input).forEach(function (key) {
      targetObject[key] = _this.convertValue(input[key], typeDefinition);
    });
    return targetObject;
  };

  Serializer.prototype.serializeProperty = function (target, property, instance) {
    var typeDefinition = PropertyTypeDefinition_1.PropertyTypeDefinition.fromObject(instance, property);

    if (!typeDefinition) {
      this.handleSourcePropertyWithoutDefinition(target, property, instance);
      return;
    }

    var logger = this.logger;

    if (typeDefinition.noSerialization()) {
      if (logger) {
        logger.debug("[Serializer] Property '" + property + "' marked to prevent serialization");
      }

      return;
    } // Look if there is a Property Type Definition for the property


    var targetKey;

    if (typeDefinition.rename) {
      targetKey = typeDefinition.rename;

      if (logger) {
        logger.debug("[Serializer] Rename '" + property + "' to '" + targetKey + "'");
      }
    } else {
      targetKey = property;
    }

    var prepared = this.prepareProperty(instance[property], property, typeDefinition);

    if (logger) {
      logger.debug("[Serializer] Serialize property '" + property + "' " + ("of type '" + Util_1.Util.inspectType(instance[property]) + "' ") + ("to type '" + Util_1.Util.inspectType(prepared) + "'"));
    }

    target[targetKey] = prepared;
  };

  Serializer.prototype.prepareProperty = function (value, key, typeDefinition) {
    var type = typeDefinition.type; // Handle `null` or `undefined`

    if (value === null || value === undefined) {
      return value;
    }

    try {
      if (typeDefinition.hasMultiple()) {
        return this.prepareFromCollection(value, typeDefinition);
      }
    } catch (error) {
      if (error instanceof SerializationError_1.SerializationError) {
        throw new SerializationError_1.SerializationError("Error while serializing value for key '" + key + "': " + error.message, error.meta);
      } else {
        throw error;
      }
    } // Handle generic objects or untyped values


    if (typeof type === 'function' && type === Object.prototype.constructor) {
      return value;
    } // Handle enum types


    if (typeof type === 'object' && type.constructor) {
      return value;
    }

    if (typeof type === 'undefined') {
      return value;
    }

    try {
      // If `type` is a primitive type check if the source value already has the correct type
      if (PrimitiveTypeEnum_1.isPrimitiveTypeEnum(type)) {
        return this.preparePrimitiveProperty(value, type);
      }

      return this.convertValue(value, typeDefinition);
    } catch (error) {
      if (error instanceof SerializationError_1.SerializationError) {
        throw new SerializationError_1.SerializationError("Error while serializing value for key '" + key + "': " + error.message, error.meta);
      } else {
        throw error;
      }
    }
  };
  /**
   * If no target key could be detected for sourceKey check if there is a PropertyTypeDefinition
   *
   * @param {T} target
   * @param {string} sourceKey
   * @param {S} source
   */


  Serializer.prototype.handleSourcePropertyWithoutDefinition = function (target, sourceKey, source) {
    var logger = this.logger;
    var sourceValue = source[sourceKey];
    var classTypeDefinition = ClassLevel_1.ClassTypeDefinition.fromObject(source);

    if (!classTypeDefinition || classTypeDefinition.ignoreUnknownFields()) {
      if (logger) {
        logger.log("[Serializer] Property '" + sourceKey + "' in '" + Util_1.Util.inspectType(source) + "' could not be serialized");
      }

      return;
    }

    if (classTypeDefinition.denyUnknownFields()) {
      throw new SerializationError_1.SerializationError("Property '" + sourceKey + "' in '" + Util_1.Util.inspectType(source) + "' could not be found");
    }

    if (classTypeDefinition.addUnknownFields()) {
      if (logger) {
        logger.debug("[Serializer] Serialize unknown property '" + sourceKey + "' of '" + Util_1.Util.inspectType(source) + "'");
      }

      target[sourceKey] = sourceValue;
    }
  };

  Serializer.prototype.assertObject = function (input) {
    if (typeof input !== 'object') {
      throw new SerializationError_1.SerializationError("Argument 'input' must be an object, '" + typeof input + "' given");
    }
  };

  Serializer.prototype.preparePrimitiveProperty = function (value, type) {
    // E.g. `"string" === "String".toLowerCase()`
    var typeName = PrimitiveTypeEnum_1.typeNameForEnum(type);

    if (typeof value === typeName.toLowerCase()) {
      return value;
    } // E.g. `"text".constructor.name === "String"`


    if (value && typeof value === 'object' && value.constructor.name === typeName) {
      return value;
    }

    if (type === PrimitiveTypeEnum_1.PrimitiveTypeEnum.Boolean) {
      return !!value;
    } else if (type === PrimitiveTypeEnum_1.PrimitiveTypeEnum.Number) {
      return parseFloat('' + value);
    } else if (type === PrimitiveTypeEnum_1.PrimitiveTypeEnum.String) {
      return value !== undefined && value !== null ? '' + value : '';
    } else if (type === PrimitiveTypeEnum_1.PrimitiveTypeEnum.Null) {
      return null;
    } else if (type === PrimitiveTypeEnum_1.PrimitiveTypeEnum.Undefined) {
      return undefined;
    }

    return undefined;
  };

  return Serializer;
}();

exports.Serializer = Serializer;